import { LinkableEntityType } from '@api';
import { LegacyAnchor } from '@common';

type FestivalAnchorPropsType = {
  festival: LinkableEntityType;
  children?: React.ReactNode;
};

export const FestivalAnchor: React.FC<FestivalAnchorPropsType> = ({
  festival,
  children,
}) => {
  return (
    <LegacyAnchor href={`/projects/festivals/${festival.id}`}>
      {children ?? festival.name}
    </LegacyAnchor>
  );
};
